/**
 * @flow
 */

import React, { useMemo, useCallback } from 'react';
import { property, chain } from 'lodash';

import { Select } from '../../../../components';

const mapMasters = masters =>
    chain(masters)
        .uniqBy(property('id'))
        .map(master => ({
            key: master.id,
            value: master.id,
            text: `${master.firstName} ${master.lastName || ''}`,
        }))
        .filter(property('value'))
        .value();

// `meta`/`dispatch`/`change` (redux-form leftovers) and the raw `masters` list
// are stripped so they don't leak onto the underlying Select.
const MasterSelect = ({
    meta,
    dispatch,
    masters,
    change,
    onChange,
    ...props
}) => {
    const options = useMemo(() => mapMasters(masters), [masters]);

    const handleChange = useCallback(
        (e, { value }) => {
            setTimeout(() => {
                onChange(value);
            }, 0);
        },
        [onChange],
    );

    return <Select {...props} options={options} onChange={handleChange} />;
};

export default MasterSelect;
